import request from '../utils/request'

/**
 * 表单系统提交
 * @param
 * {
 *   realname: this.phoneNo, 姓名
 *   mobile: this.phoneNo, 手机号
 *   activity_id: 20200828, 活动id 由产品提供
 *   blog_url: getQueryString('utm_source') || '', 从哪里点击来的
 *   googleplus: window.sessionId, 这里诸葛的埋点信息  sid + '&' + did 这样连接而成
 *   extend1: this.phoneNo // 扩展信息 没用的话就传手机号就行
 * }
 * @returns {*}
 */
export function submitFormSys(data) {
  return request({
    // eslint-disable-next-line no-undef
    url: process.env.VUE_APP_BASE_collectUrl + '/usercollect/registV2/',
    method: 'POST',
    data: data,
    headers: {}
  })
}

/***
 *  获取验证码
 * @param { phoneNo: this.phoneNo} //参数为手机号
 * @returns {*}
 */
export function getVerificationCode(params) {
  return request({
    // eslint-disable-next-line no-undef
    url: process.env.VUE_APP_BASE_onlineUrl + '/online/verificationCode/sendPhoneCode',
    method: 'get',
    params: params
  })
}

/**
 * 验证验证码是否正确
 * @param {
 *    userName: this.phoneNo, 用户名 一般是手机号
 *    code: this.code,        输入的验证码
 *    rememberMe : true,      表示是否记住登录状态 默认写个ture 就行
 *    loginTerminal: "pc",    表示端 pc 就写pc 手机就写 h5
 * }
 * @returns {*}
 */
export function registerByCode(data) {
  return request({
    // eslint-disable-next-line no-undef
    url: process.env.VUE_APP_BASE_onlineUrl + '/online/user/loginAndRegisterByCode',
    method: 'POST',
    data: data,
    headers: {}
  })
}

/**
 * 领取课程方法 参数我不记得了 需要和查看后端提供的格式
 * @param data
 * @returns {*}
 */

export function saveOrder(data) {
  return request({
    // eslint-disable-next-line no-undef
    url: process.env.VUE_APP_BASE_onlineUrl + '/web/save',
    method: 'POST',
    data: data,
    headers: {
      'Content-type': 'application/json;charset=UTF-8'
    }
  })
}

/**
 * 获取优惠券
 * @param {
 *   name: phone 电话号码,
 *   mobile: phone 电话号码,
 *   verificationCode: 验证码,
 *   campaignId: 优惠卷id,
 *   blog_url : 从哪里来的，
 *   field1： // 感觉是扩展字段
 *   field3 : '' 传递的是当钱href
 *
 * }
 * @returns {Promise<unknown>|*}
 */

export function getVertialcode(data) {
  if (!data.campaignId) {
    return new Promise(resolve => { }, reject => {
      reject('需要优惠卷编码')
    })
  }
  return request({
    // eslint-disable-next-line no-undef
    url: process.env.VUE_APP_BASE_mUrl + "/campaign/" + data.campaignId + "/form",
    method: 'POST',
    data: data,
    headers: {
      'Content-type': 'application/x-www-form-urlencoded'
    }
  })
}

/**
 * 检查用户是否领取锅优惠卷
 * @param {
 *   mobile 电话号码
 *   couponGroupSerialNo应该是优惠卷的批次号
 * }
 * @returns {*}
 */

export function checkCoupon(data) {
  return request({
    // eslint-disable-next-line no-undef
    url: process.env.VUE_APP_BASE_appBaseUrl + "/bxg/coupon/group/mobile",
    method: 'get',
    headers: {
      'Content-type': 'application/json;charset=UTF-8'
    }
  })
}

export function getCoin(params,sign) {
  return request({
    // eslint-disable-next-line no-undef
    url: process.env.VUE_APP_BASE_gatewayUrl + "/activity-api/points/GET/activityPoints",
    method: 'get',
    headers: {
      "Authorization":sign,
      'Content-type': 'application/json;charset=UTF-8'
    },
    params
  })
}

export function consumeCoin(data,sign) {
  return request({
    // eslint-disable-next-line no-undef
    url: process.env.VUE_APP_BASE_gatewayUrl + "/activity-api/points/POST/fluctuate",
    method: 'post',
    headers: {
      "Authorization":sign,
      'Content-type': 'application/x-www-form-urlencoded'
    },
    data
  })
}

